<template>
  <v-app-bar app color="primary" dark>
    <v-app-bar-nav-icon @click.stop="goTo()" />
    <v-toolbar-title>UNNC E-Calendar</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-icon class="mr-2" @click="logout">mdi-logout</v-icon>
  </v-app-bar>
</template>

<script>
export default {
  name: "NaviBar",
  data: () => {
    return {
      drawer: false,
    };
  },
  methods: {
    goTo() {
      if (this.$route.path != "/") this.$router.push("/");
    },
    logout() {
      const url = "https://www.nottingham.edu.cn";
      localStorage.clear();
      window.location = url;
    },
  },
};
</script>

<style>
</style>